import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { PrimeIcons } from "primereact/api";

const NameFilter = ({ filterApplyCallback, value }) => {
  const handleChange = useCallback(
    (evt) => {
      filterApplyCallback(evt.target.value);
    },
    [filterApplyCallback]
  );

  return (
    <IconField>
      <InputIcon className={PrimeIcons.SEARCH} />
      <InputText onChange={handleChange} value={value || ""} />
    </IconField>
  );
};

NameFilter.propTypes = {
  filterApplyCallback: PropTypes.func,
  value: PropTypes.string,
};

export default NameFilter;
